import { useShallow } from 'zustand/react/shallow'
import { usePrintAgentStore } from '../store/usePrintAgentStore'

export function usePrintAgent() {
  return usePrintAgentStore(useShallow((state) => ({
    isConnected: state.connectionStatus === 'connected',
    connectionStatus: state.connectionStatus,
    serverInfo: state.serverInfo,
    printers: state.printers,
    selectedPrinter: state.selectedPrinter,
    selectedPrinterId: state.selectedPrinterId,
    cashlogyConfigured: state.cashlogyConfigured,
    cashlogyTerminalCode: state.cashlogyTerminalCode,
    cashlogyHealth: state.cashlogyHealth,
    cashlogyConnectors: state.cashlogyConnectors,
    cashlogyConnectorsLoaded: state.cashlogyConnectorsLoaded,
    cashlogyReady: state.cashlogyConfigured
      && state.cashlogyHealth?.enabled === true
      && state.cashlogyHealth.ok === true
      && state.cashlogyHealth.sessionState === 'ready',
    isDiscovering: state.isDiscoveringPrinters,
    discoveryProgress: state.discoveryProgress,
    currentJob: state.currentJob,
    jobs: state.jobs,
    preferences: state.preferences,
    lastError: state.lastConnectionError,
    lastConnectionCheckAt: state.lastConnectionCheckAt,
    lastSuccessfulConnectionAt: state.lastSuccessfulConnectionAt,
    lastResponseTimeMs: state.lastResponseTimeMs,
    lastPrintAt: state.lastPrintAt,
    isCheckingConnection: state.isCheckingConnection,
    isLoadingServerInfo: state.isLoadingServerInfo,
    isLoadingPrinters: state.isLoadingPrinters,
    isSelectingPrinter: state.isSelectingPrinter,
    isTestingPrinter: state.isTestingPrinter,
    isPrintingTicket: state.isPrintingTicket,
    isOpeningCashDrawer: state.isOpeningCashDrawer,
    isLoadingJobs: state.isLoadingJobs,
    isCheckingCashlogy: state.isCheckingCashlogy,
    isLoadingCashlogyConnectors: state.isLoadingCashlogyConnectors,
    isDiscoveringCashlogyConnectors: state.isDiscoveringCashlogyConnectors,
    isRecoveringCashlogy: state.isRecoveringCashlogy,
    cashlogyConnectorAction: state.cashlogyConnectorAction,
    baseUrl: state.baseUrl,
    hasToken: Boolean(state.token),
    checkConnection: state.checkConnection,
    loadServerInfo: state.loadServerInfo,
    loadPrinters: state.loadPrinters,
    discoverPrinters: state.discoverPrinters,
    selectPrinter: state.selectPrinter,
    testPrinter: state.testPrinter,
    printTicket: state.printTicket,
    openCashDrawer: state.openCashDrawer,
    loadJobs: state.loadJobs,
    setBaseUrl: state.setBaseUrl,
    setToken: state.setToken,
    updatePreferences: state.updatePreferences,
    updateCashlogyConfiguration: state.updateCashlogyConfiguration,
    checkCashlogyHealth: state.checkCashlogyHealth,
    loadCashlogyConnectors: state.loadCashlogyConnectors,
    discoverCashlogyConnectors: state.discoverCashlogyConnectors,
    selectCashlogyConnector: state.selectCashlogyConnector,
    initializeCashlogyConnector: state.initializeCashlogyConnector,
    recoverCashlogy: state.recoverCashlogy,
    clearError: state.clearError,
    resetConfiguration: state.resetConfiguration,
    getDiagnosticReport: state.getDiagnosticReport,
  })))
}

